<main id="main">
        <div class="mobile_version-backbutton">
                <a class="mobile-header" onclick="history.back()">
                        <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""> </span>Sponsors </a>
        </div>
        <!-- ======= Clients Section ======= -->
        <section id="clients" class="clients sponser">
                <div class="container" data-aos="fade-up">
                        <div class="topTitle">
                                <h2>Sponsors</h2>
                        </div>
                        <div class="sponserSectionDiv" *ngFor="let group of groupedSponsors">
                                <div class="titleMaindiv">
                                        <img *ngIf="group.categoryImage" [src]="group.categoryImage"
                                                alt="{{ group.categoryName }}" class="category-logo mb-2" />
                                        <h3 class="titleheadingDiv">{{ group.categoryName }}</h3>
                                </div>
                                <div class="mainList">
                                        <ul>
                                                <li class="logo" *ngFor="let sponsor of group.sponsors"
                                                        [title]="sponsor.title || sponsor.brandName || sponsor.name">
                                                        <a *ngIf="hasSponsorLink(sponsor); else sponsorLogoCard"
                                                                [href]="getSponsorLink(sponsor)" target="_blank"
                                                                rel="noopener noreferrer" class="sponsor-card-link">
                                                                <div class="mainlogo">
                                                                        <img [src]="sponsor.photo"
                                                                                alt="{{ sponsor.title || sponsor.brandName || sponsor.name }}"
                                                                                class="img-fluid sponsor-img" />
                                                                </div>
                                                        </a>
                                                        <ng-template #sponsorLogoCard>
                                                                <div class="mainlogo">
                                                                <img [src]="sponsor.photo"
                                                                        alt="{{ sponsor.title || sponsor.brandName || sponsor.name }}"
                                                                        class="img-fluid sponsor-img" />
                                                                </div>
                                                        </ng-template>
                                                </li>
                                        </ul>
                                </div>
                        </div>
                        <div *ngIf="groupedSponsors?.length === 0" class="text-center my-5">
                                <p>No sponsors found.</p>
                        </div>
                </div>
        </section>
</main><!-- End #main -->
